import { Injectable } from '@angular/core';
import { ApiProvider } from '../api/api';
import { BibItem } from '../item/item';
import { AppState } from '../../config/state';
import fetch from 'node-fetch';
import moment from 'moment';
import { DatabaseProvider } from '../database/database';
import { DigitalItemsProvider } from '../digital-items/digital-items';
// import JSON5 from 'JSON5';

@Injectable()
export class PatronProvider {
  constructor(private api: ApiProvider, private state: AppState, private db: DatabaseProvider, private digital : DigitalItemsProvider) {

  }
  async apiGetSummaryDetails(barcode: string, pin?: string): Promise<PatronDetails> {
    let demoCards = {
      21268023168444: true,
      28076010040820: true,
    }
    if (this.state.demo && demoCards[barcode]){

      return this.fakeDetails(barcode);
    }
    let params = `barcode:"${barcode}" `;
    if (pin) {
      params += ` pin:"${pin}" `;
    }
    const query = `{
      patronDetails(${params}){
        id
        owed
        name
        email
        phone
        barcode
        address
        lastName
        firstName
        manualBlock
        residentCategory
        patronType
        cardCampaign
        noticePreference
        dob
        expires
        user1
        user2
        user3
        user4
        user5
        alerts { field content }
        notes { field content }
        homeBranch { code name }
        homeBranchId
        addressDetails {
          address1
          address2
          city
          state
          cityState
          zip
        }
      }
    }`;
    let details = await this.api.query(query);
    // console.log(details.patronDetails)
    return details && details.patronDetails ? details.patronDetails : null;
  }
  sip2DirectGetSummaryDetails(barcode: string, pin?: string): Promise<PatronDetails> {
	  return window.Bridge.coSip2.patronInfomation(barcode, pin).then(result=>{
		if(result){
			// console.log(result);
			if(!result.validPatron) return null;
			if(pin && !result.validPatronPassword) return null;
			console.log("Login done via sip2");
			return {
				"id": result.patronIdentifier,
				"owed": result.feeAmount,
				"name": result.personalName,
				"email": result.email,
				"phone": result.phone,
				"barcode": result.patronIdentifier,
				"address": result.homeAddress,
				"lastName": result.personalName?result.personalName.split(' ').slice(-1).join(' '):null,
				"firstName": result.personalName?result.personalName.split(' ').slice(0, -1).join(' '):null,
				"homeBranch": null,
				"homeBranchId": null
			}
		}
	  })
  }

  legacyApiGetHolds(barcode: string, pin: string, patronId:number): Promise<Array<PatronHold>> {
	return fetch(`https://api.communico.co/v2/${this.state.client.keyword}/sierra/patron/holds/${patronId}/${barcode}/${pin}`).then(res=>res.json()).then(result=>{
		if(result.status!=="success") throw new Error();
		console.log("holds listed via legacy API");
		if (result.data.total===0) return [];
		return result.data.entries.map(hold=>{
			return {
				"id": hold.id,
        "status": hold.status.name,
        "statusCode": hold.status.code,
				"postion": hold.priority,
				"holdDate": hold.placed,
				"queueLength": hold.priorityQueueLength,
        "pickupLocation": hold.pickupLocation,
        "frozen": hold.frozen,
				"bib": {
				  "id": hold.bib.id,
				  "ids": hold.bib.isbns?hold.bib.isbns.map(isbn=>({"type":"ISBN", "id":isbn})):[],
				  "title":hold.bib.title,
				  "author": hold.bib.author,
				  "authors": [],
				  "publisher": null,
				  "publishYear": hold.bib.publishYear,
				  "pageCount": null,
				  "averageRating": null,
				  "ratingsCount": null,
				  "readingModes": null,
				  "available": null,
				  "format": hold.bib.typeName,
				  "language": null,
				  "previewLink": null,
				  "imageLinks": null,
				  "isbns": hold.bib.isbns,
				  "upcs": [],
				  "subjects": [],
				  "summaries": [],
				  "series": [],
				  "notes": []
				}
			}
		});
  	});
  }
  legacyApiGetCheckouts(barcode: string, pin: string, patronId:number): Promise<Array<PatronCheckout>> {
	return fetch(`https://api.communico.co/v2/${this.state.client.keyword}/sierra/patron/checkouts/${patronId}/${barcode}/${pin}`).then(res=>res.json()).then(result=>{
		if(result.status!=="success") throw new Error();
		console.log("checkouts listed via legacy API");
		if (result.data.total===0) return [];
		return result.data.entries.map(checkout=>{
			return {
				"id": checkout.id,
				"dueDate": checkout.dueDate,
				"outDate": moment(checkout.outDate).format("YYYY-MM-DD"),
				"barcode": checkout.barcode? checkout.barcode : '', //we may need this
				"renewals": checkout.numberOfRenewals,
				"bib": {
				  "id": checkout.bib.id,
				  "ids": checkout.bib.isbns?checkout.bib.isbns.map(isbn=>({"type":"ISBN", "id":isbn})):[],
				  "title":checkout.bib.title,
				  "author": checkout.bib.author,
				  "authors": [],
				  "publisher": null,
				  "publishYear": checkout.bib.publishYear,
				  "pageCount": null,
				  "averageRating": null,
				  "ratingsCount": null,
				  "readingModes": null,
				  "available": null,
				  "format": checkout.bib.typeName,
				  "language": null,
				  "previewLink": null,
				  "imageLinks": null,
				  "isbns": checkout.bib.isbns,
				  "upcs": [],
				  "subjects": [],
				  "summaries": [],
				  "series": [],
				  "notes": []
				}
			}
		});
  	});
  }
  legacyApiGetSummaryDetails(barcode: string, pin?: string): Promise<PatronDetails> {
    if (this.state.overrideILSauth){
      return fetch(`https://api.communico.co/v2/${this.state.client.keyword}/sip2/patron/details/${barcode}/${pin}`).then(res=>res.json()).then(result=>{
        if(result.status!=="success")return false;
        console.log("Login done via legacy API");
        let firstName: string, lastName: string = "";
        if(result.data.name && result.data.name.includes(",")) { // last, first (tempe)
          firstName = result.data.name.split(",", 2)[1].trim();
          lastName = result.data.name.split(",", 2)[0].trim();
        } else { // first m last (rapid city)
          const parts = result.data.name.split(" ");
          firstName = parts[0].trim();
          lastName = parts.length > 1 ? parts[parts.length - 1].trim() : "";
        }
        return {
          "id": result.data.barcode,
          "owed": result.data.moneyOwed,
          "name": result.data.name,
          "email": result.data.email||null,
          "phone": result.data.phone||null,
          "barcode": result.data.barcode,
          "address": result.data.address||null,
          "firstName": firstName,
          "lastName": lastName,
          "homeBranch": null,
          "homeBranchId": result.data.homeLibraryCode
        }
      }).catch(err=>false);
    }
	return fetch(`https://api.communico.co/v2/${this.state.client.keyword}/sierra/patron/details/${barcode}/${pin}`).then(res=>res.json()).then(result=>{
		if(result.status!=="success")return false;
    console.log("Login done via legacy API");
    if (result.data.names && result.data.names.length > 0){
      result.data.names[0].first_name = result.data.names[0].first_name.split(' ').map(w=>w.charAt(0).toUpperCase()+w.substr(1)).join(' ') || null;
      result.data.names[0].last_name = result.data.names[0].last_name.split(' ').map(w=>w.charAt(0).toUpperCase()+w.substr(1)).join(' ') || null;
    }
    const firstName = result.data.names && result.data.names.length > 0 ? result.data.names[0].first_name:null;
    const lastName = result.data.names && result.data.names.length > 0 ? result.data.names[0].last_name:null;
		return {
			"id": result.data.id,
			"owed": result.data.moneyOwed,
			"name": result.data.names && result.data.names.length > 0 ? `${result.data.names[0].first_name} ${result.data.names[0].last_name}` : "",
			"email": result.data.emails && result.data.emails.length > 0 ? result.data.emails[0]:"",
			"phone": result.data.phones && result.data.phones.length > 0 ? result.data.phones[0]:"",
			"barcode": result.data.barcodes && result.data.barcodes.length > 0 ? result.data.barcodes[0]:"",
			"address": result.data.addresses && result.data.addresses.length > 0 && result.data.addresses[0].lines ? result.data.addresses[0].lines:[],
			"lastName": this.state.reverseNameOrder ? lastName : firstName,
			"firstName": this.state.reverseNameOrder ? firstName : lastName,
			"homeBranch": null,
			"homeBranchId": result.data.homeLibraryCode
		}
	}).catch(err=>false);
  }
  async getSummaryDetails(barcode: string, pin?: string): Promise<PatronDetails> {
	// if(this.state.directSip2 && window.Bridge.coSip2){
	// 	const result = await this.sip2DirectGetSummaryDetails(barcode, pin);
	// 	if(result)return result;
  // }
  let demoCards = {
    21268023168444: true,
    28076010040820: true,
  }
  if (this.state.demo && demoCards[barcode]){

    return this.fakeDetails(barcode);
  }
	// const data = await this.apiGetSummaryDetails(barcode, pin);
	// console.log(JSON.stringify(data));
	// return data;
	return this.apiGetSummaryDetails(barcode, pin);
  }

  async createPatron(patron: any): Promise<any>{
	let details = '';
	Object.keys(patron).forEach(k => {
		details+=`${k}:"${patron[k]}" `
	});
    const query = `
      mutation{
		createPatron(details:{${details}}) {
			status
			message
			patronId
			barcode
		}
	}
	`;
	let res = await this.api.query(query, patron);
	if (res && res.createPatron) {
		return res.createPatron
	}else{
		return {status:false, message:"Something went wrong"};
	}
	}
  async updatePatronDetails(barcode: any, pin: any, details: any): Promise<any>{
    let updated = false;
    // patron.firstName = "Communico";
    // patron.lastName = "Testing 12";

    // @TODO: COM-636 Send reduced query payload - only send what has changed and let the cloud function do the merging
    // console.log(`barcode: "${barcode}" pin: "${pin}" details: ${JSON5.stringify(details, {quote: '"'})}`)
    /* const query = `
      mutation{
        updatePatronDetails(barcode: "${barcode}" pin: "${pin}" details: ${JSON5.stringify(details, {quote: '"'})}) {
          status
          message
        }
      }
    `*/
    const query = `
      mutation{
        updatePatronDetails(
          barcode: "${barcode}"
          pin: "${pin}"
          details:{
            firstName:"${details.firstName || ''}"
            lastName:"${details.lastName || ''}"
            ${ details.pin ? 'pin:"' + details.pin + '"' : ''}
            address:["${details.street || ''}", "${details.city || ''}", "${details.state || ''} ${details.zip || ''}"]
            email:"${details.email || ''}"
            phone:"${details.phone || ''}"
            homeBranchId:"${details.homeBranchId || ''}"
            manualBlock: "${details.manualBlock || ''}"
            residentCategory: "${details.residentCategory || ''}"
            patronType: "${details.patronType || ''}"
            cardCampaign: "${details.cardCampaign || ''}"
            dob: "${details.dob || ''}"
            notificationPreference: "${details.noticePreference || ''}"
            cityState: "${details.cityState || ''}"
            expires: "${details.expires || ''}"
            user1: "${details.user1 || ''}"
            user2: "${details.user2 || ''}"
            user3: "${details.user3 || ''}"
            user4: "${details.user4 || ''}"
            user5: "${details.user5 || ''}"
          }
        ){
          status
          message
        }
      }
    `
    //5000127211
    let res = await this.api.query(query, details);
    if (res && res.updatePatronDetails) {
        updated = res.updatePatronDetails.status;
        if (res.updatePatronDetails.status){
          let pats = this.db.getCollection('patrons');
          pats.findAndRemove({id: details.id});
          const { $loki, ...rest } = details;
          pats.insertOne(rest); // Do not send $loki up to DB. Known issue https://github.com/techfort/LokiJS/issues/681#issuecomment-394270952
          await this.db.saveDB();
        }
    }
    return res.updatePatronDetails;
  }

  async updatePatronPin(patron: any): Promise<any>{
    let updated = false;

    const query = `
      mutation{
        updatePatronDetails(barcode: "${patron.barcode}" details:{pin:"${patron.pin}"}) {
          status
          message
        }
      }
    `
    let res = await this.api.query(query, patron);
    if (res && res.updatePatronDetails) {
        updated = res.updatePatronDetails;
    }
    return updated
  }
  async getFullDetails(barcode: string, pin?: string): Promise<PatronDetails> { //this is slow, call getSummaryDetails unless you really need this
    let demoCards = {
      21268023168444: true,
      28076010040820: true,
    }
    if (this.state.demo && demoCards[barcode]){

      return this.fakeDetails(barcode);
    }

    let params = `barcode:"${barcode}" `;
    if (pin) {
      params += ` pin: "${pin}" `;
    }
    const query = `{
      patronDetails(${params}){
        id, owed, name, fines {
          id, bib {
              id
              ids { type id }
              title
              author
              authors
              publisher
              publishYear
              pageCount
              averageRating
              ratingsCount
              readingModes { text image }
              available
              format
              language
              previewLink
              imageLinks { type url }
              isbns
              upcs
              subjects
              summaries { text source }
              series
              notes
          }, amount, amountPaid, description
        }, email phone holds {
          id, bib {
              id
              ids { type id }
              title
              author
              authors
              publisher
              publishYear
              pageCount
              averageRating
              ratingsCount
              readingModes { text image }
              available
              format
              language
              previewLink
              imageLinks { type url }
              isbns
              upcs
              subjects
              summaries { text source }
              series
              notes
          }, status, postion, holdDate, queueLength, pickupLocation {
            code
            name
          }
        }, barcode, address, lastName, checkouts {
          id, bib {
              id
              ids { type id }
              title
              author
              authors
              publisher
              publishYear
              pageCount
              averageRating
              ratingsCount
              readingModes { text image }
              available
              format
              language
              previewLink
              imageLinks { type url }
              isbns
              upcs
              subjects
              summaries { text source }
              series
              notes
          }, dueDate, outDate, barcode, renewals
        }, firstName, homeBranch {
          code
          name
        }, homeBranchId, addressDetails {
          address1
          address2
          city
          state
          cityState
          zip
        }
        user1
        user2
        user3
        user4
        user5
      }
    }`;
    let details = await this.api.query(query);
    return details && details.patronDetails ? details.patronDetails : null;
  }

  public async cancelBooking(booking):Promise<any>{
    return fetch(`https://${this.state.client.keyword}.libnet.info/myreservations?action=cancel&bookingid=${booking.reservationId}&ref=${'something'}`).then(res => res.json()).then(result => {
      console.log(result)
      if(result.status!=="success")return false;
    })
  }

  async getRoomBookings(barcode: string, pin?: string) {

    let params = `barcode:"${barcode}" `;
    if (pin) {
      params += ` pin: "${pin}" `;
    }
    const query = `{
      patronDetails(${params}) {
        id name
        reservations {
          reservationId
          locationId
          locationName
          roomId
          roomName
          startTime
          endTime
          contactPhone
          contactName
          contactEmail
          bookingType
          groupName
          type
          setupTime
          breakdownTime
          expectedAttendees
          eventId
          eventSeriesId
          displayName
          status
          roomImage
        }
      }
    }`

    let details = await this.api.query(query);
    return (details && details.patronDetails && details.patronDetails.reservations) ? details.patronDetails.reservations : null;
  //   return details.patronDetails.reservations = [{reservationId: 128311, locationId: 182, locationName: "Bowie", roomId: 250, roomName: "Study Room 3", startTime: "2019-06-12 15:30:00", endTime: "2019-06-12 17:30:00", contactPhone: "12376194691", contactName: "Jeff", contactEmail: "ray@communico.us", bookingType: null, type:null, groupName: "The funnies",setupTime: "30", breakdownTime: "30", expectedAttendees: "20", eventId: 11230, eventSeriesId: null, displayName: "Down with the comedians", status: "approved"},
  //   {reservationId: 128313, locationId: 182, locationName: "Bowie", roomId: 250, roomName: "Study Room 3", startTime: "2018-06-12 15:30:00", endTime: "2018-06-12 17:30:00", contactPhone: "12376194691", contactName: "Jeff", contactEmail: "ray@communico.us", bookingType: null, type:null, groupName: "The funnies",setupTime: "30", breakdownTime: "30", expectedAttendees: "20", eventId: 11020, eventSeriesId: null, displayName: "Down with the comedians", status: "approved"}]

  }

  async getPatronFormOptions() {
    const query = `{
      patronFormOptions {
        manualBlock {
          id
          name
        }
        patronTypes {
          id
          name
        }
        residentCategory {
          id
          name
        }
        cardCampaign {
          id
          name
        }
        noticePreference {
          id
          name
        }
        cityStates {
          id
          name
        }
      }
    }`
    let details = await this.api.query(query);
    return details && details.patronFormOptions ? details.patronFormOptions : null;
  }

  async getRegisteredEvents(barcode: string, pin?: string) {
    let params = `barcode:"${barcode}" `;
    if (pin) {
      params += ` pin: "${pin}" `;
    }
    const query = `{
      patronDetails(${params}) {
        id name
        registeredEvents {
          ages
          eventId
          recurringId
          title
          subTitle
          shortDescription
          description
          eventStart
          eventEnd
          locationId
          locationName
          roomId
          roomName
          contactName
          ticketed
          allowReg
          registrationOpens
          registrationCloses
          maxAttendees
          allowWaitlist
          eventImage
          status
          isPrivateEvent
          globalFeatured
          branchFeatured
          newEventId
          isModified
          reportingCategory
          totalRegistrants
          totalWaitlist
          setupTime
          breakdownTime
          parentKeyword
          types
        }
      }
    }`

    let details = await this.api.query(query);
    return (details && details.patronDetails && details.patronDetails.registeredEvents) ? details.patronDetails.registeredEvents : null;
  }

  async getFines(barcode: string, pin?: string): Promise<Array<PatronFine>> {
    let demoCards = {
      21268023168444: true,
      28076010040820: true,
    }
    if (this.state.demo && demoCards[barcode]){

      return this.fakeDetails(barcode, 'fines');
    }
    let params = `barcode:"${barcode}" `;
    if (pin) {
      params += ` pin: "${pin}" `;
    }
    const query = `{
      patronDetails(${params}){
        fines {
          id, bib {
              id
              ids { type id }
              title
              author
              authors
              publisher
              publishYear
              pageCount
              averageRating
              ratingsCount
              readingModes { text image }
              available
              format
              language
              previewLink
              imageLinks { type url }
              isbns
              upcs
              subjects
              summaries { text source }
              series
              notes
          }, amount, amountPaid, description
        }
      }
    }`;
    let details = await this.api.query(query);
    return (details && details.patronDetails && details.patronDetails.fines) ? details.patronDetails.fines : null;
  };

  getHolds(barcode: string, pin?: string, patronId?:number): Promise<Array<PatronHold>> {
    let demoCards = {
      21268023168444: true
    }
    if (this.state.demo && demoCards[barcode]){
      return this.fakeDetails(barcode, 'holds');
    }
    if(pin && patronId && patronId>0){
      return this.legacyApiGetHolds(barcode, pin, patronId)
      .catch( () => {
        return this.apiGetHolds(barcode, pin);
      });
    }
    return this.apiGetHolds(barcode, pin);
  }
  async apiGetHolds(barcode: string, pin?: string): Promise<Array<PatronHold>> {
    let params = `barcode:"${barcode}" `;
    if (pin) {
      params += ` pin: "${pin}" `;
    }
    const query = `{
      patronDetails(${params}){
        holds {
          id, bib {
              id
              ids { type id }
              title
              author
              authors
              publisher
              publishYear
              pageCount
              averageRating
              ratingsCount
              readingModes { text image }
              available
              format
              language
              previewLink
              imageLinks { type url }
              isbns
              upcs
              subjects
              summaries { text source }
              series
              notes
          }, status, postion, holdDate, queueLength, frozen, isReady, isCancelled, pickupByDate, pickupLocation {
            code
            name
          }
        }
      }
    }`
    let details = await this.api.getData(query, 'holds',0);
    return (details && details.holds) ? details.holds : null;
  };
  getDigitalCheckouts(barcode: string, pin?: string):Promise<any>{
    return new Promise (async (res,rej)=>{
      let checkouts = []
      for(var service in this.state.digitalServices){
        if (this.state.digitalServices[service]){
          let items = await this.digital.legacyGetDigitalCheckout(service, barcode, pin);
          // console.log(items);
          if (items)items.forEach(itm => checkouts.push(itm));
        }
      }
      return res(checkouts);
    });
  }
  getDigitalHolds(barcode: string, pin?: string):Promise<any>{
    return new Promise (async (res,rej)=>{
      let holds = []
      for(var service in this.state.digitalServices){
        if (this.state.digitalServices[service]){
          let items = await this.digital.legacyGetDigitalHolds(service, barcode, pin);
          // console.log(items);
          if (items)items.forEach(itm => holds.push(itm));
        }
      }
      return res(holds);
    });
  }
  getCheckouts(barcode: string, pin?: string, patronId?:number): Promise<Array<PatronCheckout>> {
    if(pin && patronId && patronId>0){
      return this.legacyApiGetCheckouts(barcode, pin, patronId)
      .catch( () => {
        return this.apiGetCheckouts(barcode, pin);
      });
    }
    return this.apiGetCheckouts(barcode, pin);
  }
  async apiGetCheckouts(barcode: string, pin?: string): Promise<Array<PatronCheckout>> {
    let demoCards = {
      21268023168444: true,
      28076010040820: true,
    }
    if (this.state.demo && demoCards[barcode]){

      return this.fakeDetails(barcode, 'checkouts');
    }
    let params = `barcode:"${barcode}" `;
    if (pin) {
      params += ` pin: "${pin}" `;
    }
    const query = `{
      patronDetails(${params}){
        checkouts {
          id dueDate outDate barcode renewals bib{
            id
            ids { type id }
            title
            author
            authors
            publisher
            publishYear
            pageCount
            averageRating
            ratingsCount
            readingModes { text image }
            available
            format
            language
            previewLink
            imageLinks { type url }
            isbns
            upcs
            subjects
            summaries { text source }
            series
            notes
          }
        }
      }
    }`;
    let details = await this.api.query(query);
    // console.log('params', params, details);
    return (details && details.patronDetails && details.patronDetails.checkouts) ? details.patronDetails.checkouts : null;
  };

  async getRegisteredForEvents(barcode: string) {

    let events: any;
    let query = `{
      getEventsRegisteredFor(barcode:"${barcode}") {
        age, name, email, phone, guests, status, eventId, recurringId, libraryCard, patronBarcode, registrationId, customQuestions {
          title
          helpText
          link
          required
          validate
          regex
          type
          name
          answer
        }, patronCheckedIn, registrationTime
      }
    }`

    events = await this.api.query(query);
    // console.log('my events', events);
    return events && events.getEventsRegisteredFor ? events.getEventsRegisteredFor : null;
  }

  async patronSearch(patronQuery: any, start:number, limit: number) {
	let query = `{
		findPatron(query: ${ patronQuery } start: ${start} limit: ${limit}){
		  total start results {
			patronId
			barcode
			name
		  }
		}
	  }`

    let results = await this.api.query(query);
	  return (results && results.findPatron) ? results.findPatron : null;
	}
  async getCheckoutsForCanceledCheckout(barcode: string) {

    let query = `{
      patronDetails(barcode:"${barcode}" ) {
        checkouts{
          id dueDate outDate barcode renewals bib{
            id
          }
        }
      }
    }`

    let details = await this.api.query(query);
    // console.log('params', barcode, details);
    return (details && details.patronDetails && details.patronDetails.checkouts) ? details.patronDetails.checkouts : null;
  }

  private async fakeDetails(barcode, info?):Promise<any>{
    let patronDetails:any = false;
    switch(barcode){
      case ('21268023168444'):
        patronDetails = {
            "id": 463355,
            "owed": 1,
            "name": "Stella Staffuser",
            "fines": [{
              "id": 9821493,
              "bib": {
                "id": null,
                "ids": null,
                "title": null,
                "author": null,
                "authors": null,
                "publisher": null,
                "publishYear": null,
                "pageCount": null,
                "averageRating": null,
                "ratingsCount": null,
                "readingModes": null,
                "available": null,
                "format": null,
                "language": null,
                "previewLink": null,
                "imageLinks": null,
                "isbns": null,
                "upcs": null,
                "subjects": null,
                "summaries": null,
                "series": null,
                "notes": null
              },
              "amount": 1,
              "amountPaid": null,
              "description": "Printing Fee"
            }],
            "email": "patron@pmail.org",
            "phone": "(301) 555-1234",
            "holds": [{
              "id": 4414110,
              "bib": {
                "id": "869030",
                "ids": [],
                "title": "The pants project",
                "author": "Clarke, Cat,",
                "authors": ["Clarke, Cat,"],
                "publisher": null,
                "publishYear": 2017,
                "pageCount": null,
                "averageRating": null,
                "ratingsCount": null,
                "readingModes": null,
                "available": null,
                "format": "Book",
                "language": null,
                "previewLink": null,
                "imageLinks": null,
                "isbns": ["9781492638094", "1492638099", "9781492638094", "1492638099"],
                "upcs": [],
                "subjects": [],
                "summaries": [{
                  "text": "Eleven-year-old Liv fights to change the middle school dress code requiring girls to wear a skirt and, along the way, finds the courage to tell his moms he is meant to be a boy.",
                  "source": null
                }],
                "series": [],
                "notes": []
              },
              "status": "Cancelled",
              "postion": 0,
              "holdDate": "2019-06-06",
              "queueLength": 0,
              "pickupLocation": {
                "code": "7",
                "name": "Beltsville"
              }
            }],
            "barcode": "21268023168444",
            "address":  ["13603 Baden Westwood Rd", "Brandywine, MD 20613"],
            "lastName": "Staffuser",
            "checkouts": [{
              "id": 4333465,
              "bib": {
                "id": "1046683",
                "ids": [],
                "title": "The gate keeper",
                "author": "Todd, Charles,",
                "authors": ["Todd, Charles,"],
                "publisher": null,
                "publishYear": 2018,
                "pageCount": null,
                "averageRating": null,
                "ratingsCount": null,
                "readingModes": null,
                "available": null,
                "format": "AudioEbook",
                "language": null,
                "previewLink": "http://link.overdrive.com/?websiteID=150&titleID=3280512",
                "imageLinks": null,
                "isbns": ["9780062802330", "006280233X"],
                "upcs": [],
                "subjects": [],
                "summaries": [{
                  "text": "On a deserted road, late at night, Scotland Yard's Ian Rutledge encounters a frightened woman standing over a body, launching an inquiry that leads him into the lair of a stealthy killer and the dangerous recesses of his own memories in this twentieth installment of the acclaimed New York Times bestselling series. Hours after his sister's wedding, a restless Ian Rutledge drives aimlessly, haunted by the past, and narrowly misses a motorcar stopped in the middle of a desolate road. Standing beside the vehicle is a woman with blood on her hands and a dead man at her feet. She swears she didn't kill Stephen Wentworth. A stranger stepped out in front of their motorcar, and without warning, fired a single shot before vanishing into the night. But there is no trace of him. And the shaken woman insists it all happened so quickly, she never saw the man's face. Although he is a witness after the fact, Rutledge persuades the Yard to give him the inquiry, since he's on the scene. But is he seeking justice--or fleeing painful memories in London?Wentworth was well-liked, yet his bitter family paint a malevolent portrait, calling him a murderer. But who did Wentworth kill? Is his death retribution? Or has his companion lied? Wolf Pit, his village, has a notorious history: in Medieval times, the last wolf in England was killed there. When a second suspicious death occurs, the evidence suggests that a dangerous predator is on the loose, and that death is closer than Rutledge knows.",
                  "source": null
                }],
                "series": ["An Inspector Ian Rutledge mystery ;"],
                "notes": []
              },
              "dueDate": "2019-06-20",
              "outDate": "2019-06-06",
              "barcode": "econtent4333465",
              "renewals": 0
            }, {
              "id": 4066297,
              "bib": {
                "id": "944426",
                "ids": [],
                "title": "Harry Potter :cinematic guide",
                "author": "Baker, Felicity,",
                "authors": ["Baker, Felicity,"],
                "publisher": null,
                "publishYear": 2016,
                "pageCount": null,
                "averageRating": null,
                "ratingsCount": null,
                "readingModes": null,
                "available": null,
                "format": "eBook",
                "language": null,
                "previewLink": "http://link.overdrive.com/?websiteID=150&titleID=3027936",
                "imageLinks": null,
                "isbns": ["9781338158311", "1338158317"],
                "upcs": [],
                "subjects": [],
                "summaries": [{
                  "text": "Collects photographs and quotes, featuring Harry Potter, describing his life at Hogwarts, his relationships with friends and family, and his battles with Voldemort.",
                  "source": null
                }],
                "series": [],
                "notes": []
              },
              "dueDate": "2019-06-21",
              "outDate": "2019-06-07",
              "barcode": "econtent4066297",
              "renewals": 0
            }],
            "firstName": "Stella",
            "homeBranch": {"name":"Baden"},
            "homeBranchId": "4"
        }
      break;
      case('28076010040820'):
        patronDetails = {
          "id": 12099414,
          "owed": 40,
          "name": "PATRON, MR. SAMPLE",
          "fines": [{
            "id": 11253896,
            "bib": {
              "id": "11172071",
              "ids": [{
                "type": "ISBN",
                "id": "9780800723316"
              }, {
                "type": "LCCN",
                "id": "2015040486"
              }, {
                "type": "MARC",
                "id": "sky278996676"
              }],
              "title": "A powerful secret : a novel",
              "author": "Leman, Kevin, author.",
              "authors": ["Leman, Kevin,"],
              "publisher": null,
              "publishYear": 2016,
              "pageCount": null,
              "averageRating": null,
              "ratingsCount": null,
              "readingModes": null,
              "available": true,
              "format": "BOOK",
              "language": null,
              "previewLink": null,
              "imageLinks": null,
              "isbns": ["9780800723316"],
              "upcs": [],
              "subjects": ["First-born children", "Fiction.", "Ambition", "Choice (Psychology)", "Christian fiction.", "lcgft"],
              "summaries": [{
                "text": "Sean Worthington feels betrayed by a secret that threatens his place in the family. His next move will determine his future legacy.",
                "source": null
              }],
              "series": ["The Worthington destiny ;"],
              "notes": []
            },
            "amount": 1,
            "amountPaid": 0,
            "description": "Adjustment"
          }, {
            "id": 11223423,
            "bib": {
              "id": "10916020",
              "ids": [{
                "type": "UPC",
                "id": "093624966524"
              }, {
                "type": "MARC",
                "id": "607112281"
              }],
              "title": "Sea of cowards",
              "author": "Dead Weather (Musical group)",
              "authors": [],
              "publisher": null,
              "publishYear": 2010,
              "pageCount": null,
              "averageRating": null,
              "ratingsCount": null,
              "readingModes": null,
              "available": true,
              "format": "CD MUSIC",
              "language": null,
              "previewLink": null,
              "imageLinks": null,
              "isbns": [],
              "upcs": ["093624966524"],
              "subjects": ["Rock music", "2001-2010.", "Alternative rock music.", "Garage rock music."],
              "summaries": [],
              "series": [],
              "notes": ["Title from cover.", "Compact disc."]
            },
            "amount": 2,
            "amountPaid": 0,
            "description": "Adjustment"
          }, {
            "id": 11223422,
            "bib": {
              "id": "10946758",
              "ids": [{
                "type": "UPC",
                "id": "099923233626"
              }, {
                "type": "MARC",
                "id": "696113045"
              }],
              "title": "Sever the wicked hand",
              "author": "Crowbar (Musical group : New Orleans, La.)",
              "authors": [],
              "publisher": null,
              "publishYear": 2011,
              "pageCount": null,
              "averageRating": null,
              "ratingsCount": null,
              "readingModes": null,
              "available": true,
              "format": "CD MUSIC",
              "language": null,
              "previewLink": null,
              "imageLinks": null,
              "isbns": [],
              "upcs": ["099923233626"],
              "subjects": ["Rock music", "2001-2010.", "Sludge metal (Music)", "Heavy metal (Music)"],
              "summaries": [],
              "series": [],
              "notes": ["Compact disc.", "Lyrics in container."]
            },
            "amount": 5,
            "amountPaid": 0,
            "description": "Adjustment"
          }, {
            "id": 11223421,
            "bib": {
              "id": "10937854",
              "ids": [{
                "type": "UPC",
                "id": "886976169527"
              }, {
                "type": "MARC",
                "id": "457068543"
              }],
              "title": "She wolf",
              "author": "Shakira.",
              "authors": ["Shakira."],
              "publisher": null,
              "publishYear": 2009,
              "pageCount": null,
              "averageRating": null,
              "ratingsCount": null,
              "readingModes": null,
              "available": true,
              "format": "CD MUSIC",
              "language": null,
              "previewLink": null,
              "imageLinks": null,
              "isbns": [],
              "upcs": ["886976169527"],
              "subjects": ["Rock music", "2001-2010.", "Latin pop (Music)"],
              "summaries": [],
              "series": [],
              "notes": ["Enhanced compact disc.", "Lyrics in English and Spanish in container."]
            },
            "amount": 5,
            "amountPaid": 0,
            "description": "Adjustment"
          }],
          "email": "hello@communico.co",
          "phone": "(101) 555-0123",
          "holds": [
          //   {
          //   "id": 20402363,
          //   "bib": {
          //     "id": "10796621",
          //     "ids": [{
          //       "type": "ISBN",
          //       "id": "1594834822"
          //     }, {
          //       "type": "ISBN",
          //       "id": "9781594834820"
          //     }, {
          //       "type": "MARC",
          //       "id": "69648120"
          //     }],
          //     "title": "Season of the machete",
          //     "author": "Patterson, James, 1947-",
          //     "authors": ["Patterson, James,"],
          //     "publisher": null,
          //     "publishYear": 2006,
          //     "pageCount": null,
          //     "averageRating": null,
          //     "ratingsCount": null,
          //     "readingModes": null,
          //     "available": false,
          //     "format": "CD BOOK",
          //     "language": null,
          //     "previewLink": null,
          //     "imageLinks": null,
          //     "isbns": ["1594834822", "9781594834820"],
          //     "upcs": [],
          //     "subjects": ["Psychopaths", "Fiction.", "Murderers", "Adventure stories."],
          //     "summaries": [{
          //       "text": "Cool and glamorous, they appear to be a successful couple on a holiday.  Yet Damian and Carrie Rose are psychopathic murderers for hire.  On this picture-perfect vacation island, their target is Peter Macdonald, a dashing young American who forsakes a life of leisure to confront cold-blooded terror.",
          //       "source": null
          //     }],
          //     "series": [],
          //     "notes": ["Compact discs.", "Unabridged."]
          //   },
          //   "status": "Ready for Pickup",
          //   "statusCode": "i",
          //   "postion": 0,
          //   "holdDate": "2018-10-22",
          //   "queueLength": 2,
          //   "pickupLocation": {
          //     "code": "58",
          //     "name": "Parma"
          //   }
          // }
          ],
          "barcode": "28076010040820",
          "address": ["2111 SNOW RD", "PARMA, OH 44134"],
          "lastName": "Patron",
          "checkouts": [{
            "id": 52551554,
            "bib": {
              "id": "11172071",
              "ids": [{
                "type": "ISBN",
                "id": "9780800723316"
              }, {
                "type": "LCCN",
                "id": "2015040486"
              }, {
                "type": "MARC",
                "id": "sky278996676"
              }],
              "title": "A powerful secret : a novel",
              "author": "Leman, Kevin, author.",
              "authors": ["Leman, Kevin,"],
              "publisher": null,
              "publishYear": 2016,
              "pageCount": null,
              "averageRating": null,
              "ratingsCount": null,
              "readingModes": null,
              "available": true,
              "format": "BOOK",
              "language": null,
              "previewLink": null,
              "imageLinks": null,
              "isbns": ["9780800723316"],
              "upcs": [],
              "subjects": ["First-born children", "Fiction.", "Ambition", "Choice (Psychology)", "Christian fiction.", "lcgft"],
              "summaries": [{
                "text": "Sean Worthington feels betrayed by a secret that threatens his place in the family. His next move will determine his future legacy.",
                "source": null
              }],
              "series": ["The Worthington destiny ;"],
              "notes": []
            },
            "dueDate": "2020-02-29",
            "outDate": "2020-02-07",
            "barcode": "4004031674",
            "renewals": 3
          }, {
            "id": 52551550,
            "bib": {
              "id": "11242343",
              "ids": [{
                "type": "ISBN",
                "id": "9780451465641"
              }, {
                "type": "LCCN",
                "id": "2014430094"
              }, {
                "type": "MARC",
                "id": "sky260359979"
              }],
              "title": "It can't happen here",
              "author": "Lewis, Sinclair, 1885-1951.",
              "authors": ["Lewis, Sinclair,"],
              "publisher": null,
              "publishYear": 2014,
              "pageCount": null,
              "averageRating": null,
              "ratingsCount": null,
              "readingModes": null,
              "available": true,
              "format": "BOOK",
              "language": null,
              "previewLink": null,
              "imageLinks": null,
              "isbns": ["9780451465641"],
              "upcs": [],
              "subjects": ["Presidents", "United States", "Fiction.", "Election", "Anti-fascist movements", "Newspaper editors", "Dictators", "Fascists", "Political fiction.", "lcgft"],
              "summaries": [{
                "text": "A cautionary tale about the fragility of democracy in which an American president becomes a dictator in order to save the nation from welfare cheats, rampant promiscuity, crime, and a liberal press.",
                "source": null
              }],
              "series": [],
              "notes": []
            },
            "dueDate": "2020-02-29",
            "outDate": "2020-02-07",
            "barcode": "4004394682",
            "renewals": 4
          }, {
            "id": 52544940,
            "bib": {
              "id": "11258048",
              "ids": [{
                "type": "UPC",
                "id": "024543275329"
              }, {
                "type": "MARC",
                "id": "sky285945311"
              }],
              "title": "Hidden figures.",
              "author": "",
              "authors": [],
              "publisher": null,
              "publishYear": 2017,
              "pageCount": null,
              "averageRating": null,
              "ratingsCount": null,
              "readingModes": null,
              "available": true,
              "format": "DVD",
              "language": "eng",
              "previewLink": null,
              "imageLinks": null,
              "isbns": [],
              "upcs": ["024543275329"],
              "subjects": ["Women mathematicians", "United States", "Drama.", "African American women", "African American mathematicians", "Space race", "Biographical films.", "lcgft", "Historical films.", "Feature films.", "Video recordings for the hearing impaired.", "Video recordings for people with visual disabilities."],
              "summaries": [{
                "text": "As the United States raced against Russia to put a man in space, NASA found untapped talent in a group of African-American female mathematicians that served as the brains behind one of the greatest operations in U.S. history.  Dorothy Vaughan, Mary Jackson, and Katherine Johnson crossed all gender, race, and professional lines while their brilliance and desire to dream big, beyond anything ever accomplished before by the human race, firmly cemented them in U.S. history as true American heroes.",
                "source": null
              }],
              "series": [],
              "notes": ["Title from web page.", "Originally released as a motion picture in 2016.", "Wide screen (2.39:1).", "Special features: No limits - the life of Katherine Johnson; Moving the decimal - honoring Katherine Johnson; filming in Georgia; gallery; audio commentaries."]
            },
            "dueDate": "2020-03-02",
            "outDate": "2020-02-14",
            "barcode": "4004446629",
            "renewals": 5
          }, {
            "id": 52537592,
            "bib": {
              "id": "11147895",
              "ids": [{
                "type": "ISBN",
                "id": "9786315821264"
              }, {
                "type": "ISBN",
                "id": "631582126X"
              }, {
                "type": "UPC",
                "id": "013132617411"
              }, {
                "type": "MARC",
                "id": "sky270978242"
              }],
              "title": "St. Vincent.",
              "author": "",
              "authors": [],
              "publisher": null,
              "publishYear": 2015,
              "pageCount": null,
              "averageRating": null,
              "ratingsCount": null,
              "readingModes": null,
              "available": true,
              "format": "DVD",
              "language": "eng",
              "previewLink": null,
              "imageLinks": null,
              "isbns": ["9786315821264", "631582126X"],
              "upcs": ["013132617411"],
              "subjects": [],
              "summaries": [{
                "text": "Maggie, a single mother, moves into a new home in Brooklyn with her twelve-year old son, Oliver. Forced to work long hours, she has no choice but to leave Oliver in the care of their new neighbor, Vincent, a retired curmudgeon with a desire for alcohol and gambling. An odd friendship soon blossoms between the improbable pair. Together with a pregnant stripper, named Daka, Vincent brings Oliver along on all the stops that make up his daily routine, race track, strip club, and a dive bar.",
                "source": null
              }],
              "series": [],
              "notes": ["Originally released as a motion picture in 2014.", "Special features: Deleted scenes; Bill Murray is St Vincent: the Patron Saint of comedy."]
            },
            "dueDate": "2020-02-29",
            "outDate": "2020-02-07",
            "barcode": "4003684467",
            "renewals": 6
          }, {
            "id": 52537586,
            "bib": {
              "id": "11277715",
              "ids": [{
                "type": "ISBN",
                "id": "9781101883976"
              }, {
                "type": "ISBN",
                "id": "1101883979"
              }, {
                "type": "LCCN",
                "id": "2016046692"
              }, {
                "type": "MARC",
                "id": "sky284898165"
              }],
              "title": "Past perfect : a novel",
              "author": "Steel, Danielle, author.",
              "authors": ["Steel, Danielle,"],
              "publisher": null,
              "publishYear": 2017,
              "pageCount": null,
              "averageRating": null,
              "ratingsCount": null,
              "readingModes": null,
              "available": true,
              "format": "BOOK",
              "language": null,
              "previewLink": null,
              "imageLinks": null,
              "isbns": ["9781101883976", "1101883979"],
              "upcs": [],
              "subjects": ["Families", "Fiction.", "Moving, Household", "Ghost stories.", "lcgft"],
              "summaries": [{
                "text": "What's so perfect about the past for Sybil and Blake Gregory, a successful Manhattan couple with three children who land in San Francisco when Blake impulsively accepts the job of a lifetime as CEO of a start-up? The family moves into a grand, surprisingly affordable Pacific Heights mansion and soon meets the affable Butterfield family, who lived there a century ago. Of course the Butterfields are ghosts, and only the Gregorys can see them, but that doesn't keep the two families from leading a charmed life together.",
                "source": null
              }],
              "series": [],
              "notes": []
            },
            "dueDate": "2020-02-29",
            "outDate": "2020-02-07",
            "barcode": "4004776089",
            "renewals": 4
          }],
          "firstName": "Mr. Sample",
          "homeBranch": {
            "code": "58",
            "name": "Parma"
          },
          "homeBranchId": "58"
        }
      break;
    }
    if (info){
      return patronDetails[info];
    } else {
      return patronDetails;
    }
  }
}

export interface Branch {
  code: string;
  name: string;
}
export interface PatronFine {
  id: number;
  lastUpdate?: string;
  name: string;
  amount: number;
  amountPaid: number;
  description: string;
  bib: BibItem;
  willPay?: boolean;
}
export interface PatronHold {
  id: number;
  lastUpdate?: string;
  name: string;
  amount: number;
  amountPaid: number;
  description: string;
  status: string;
  statusCode: string;
  postion: number;
  holdDate: string;
  queueLength: number;
  pickupLocation: Branch;
  bib: BibItem;
  isReady: boolean;
  frozen?: boolean;
}
export interface PatronCheckout {
  id: number;
  lastUpdate?: string;
  dueDate: string;
  outDate: string;
  bib: BibItem;
  hasBeenRenewed: boolean;
}
export interface PatronDetails {
  id: number;
  lastUpdate?: string;
  pin?: string;
  owed?: string;
  name?: string;
  email?: string;
  phone?: string;
  barcode: string;
  address?: Array<string>;
  addressDetails?: any;
  lastName: string;
  firstName: string;
  homeBranch?: Branch;
  homeBranchId?: string;
  fines?: Array<PatronFine>;
  holds?: Array<PatronHold>;
  checkouts?: Array<PatronCheckout>;
  cityState?: string;
}



// WEBPACK FOOTER //
// ./src/providers/patron/patron.ts